<template>
    <div class="card" style="width: 28rem;">
        <img v-if="thumbnail" :src="thumbnail" class="card-img-top" alt="Thumbnail" />
        <div class="card-body">
            <h5 class="card-title">{{ name }}</h5>
            <p class="card-text">Click below to view data for this question.</p>
            <button class="btn btn-primary" @click="emit('click')">View Data</button>
        </div>
    </div>
</template>

<script setup lang="ts">
interface Props {
    name: string;
    thumbnail?: string;
}

defineProps<Props>();

// Define emits with their types
const emit = defineEmits<{
    (event: 'click'): void;
}>();
</script>

<style scoped>
.card {
    margin: 10px;
}
</style>